import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

import './styles/index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { UserProvider } from './contexts/userContext'
import { WalletProvider } from './contexts/walletContext'
import SentryFallback from './components/SentryFallback'
import { SENTRY_DSN } from './config'

// TODO: Config webpack to resolve this https://github.com/NoahZinsmeister/web3-react/blob/main/packages/example/next.config.js
window.Buffer = require('buffer/').Buffer

const history = createBrowserHistory()

Sentry.init({
  environment: process.env.NODE_ENV || 'production',
  dsn: SENTRY_DSN,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
    })
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
})

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback} showDialog>
      <BrowserRouter history={history}>
        <UserProvider>
          <WalletProvider>
            <App />
          </WalletProvider>
        </UserProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
